/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

export const PaymentComp = () => {
  return (
    <>
      {/* {_renderHeader()}
      {_renderPage()} */}
      <StateOSD
        image="https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/team_work_2_black.png"
        titleNormalText={'Coming Soon 🚀🚀🚀'}
        description={'We are building this while we speak !'}
      />
    </>
  );
};
